<template>
  <div class="qz-shortanswer" :class="{ 'qz-answered': isAnswered }">
    <!-- eslint-disable vue/no-v-html -->
    <div class="qz-stem" v-html="view.stem"></div>
    <textarea
      class="qz-shortanswer-textarea"
      :maxlength="MAX_LEN"
      aria-label="请输入你的答案"
      :disabled="isAnswered"
      :value="text"
      @input="handleInput($event.target.value)"
    ></textarea>
    <div class="qz-shortanswer-count">{{ text.length }} / {{ MAX_LEN }}</div>
    <div v-if="isAnswered" class="qz-feedback">
      <div v-if="referenceHtml" class="qz-reference" v-html="referenceHtml"></div>
      <div v-if="analysisText" class="qz-analysis" v-html="analysisText"></div>
    </div>
    <!-- eslint-enable vue/no-v-html -->
  </div>
</template>

<script>
// short_answer 无自动判分（matcher=none，契约里 feedback.right 恒为 0）：不存在"对错"高亮，
// 已答态只展示 analysis.reference（参考答案）与 analysis.text（解析）。view.stem/analysis 均为
// 服务端下发、已过 bluemonday 消毒的内容，走 v-html 是契约默认行为；**text 输入框里学生自己敲
// 的文字永远只用 :value 绑定/文本插值，不会被塞进任何 v-html**。
// maxlength=2000：后端 answer.text 上限是 8KB（字节），这里按字符数给一个更友好的前端提示上限，
// 不是字节精确换算——真正兜底仍在后端。
const MAX_TEXT_LENGTH = 2000

export default {
  name: 'ShortAnswerRenderer',
  props: {
    view: {
      type: Object,
      required: true
    },
    session: {
      type: Object,
      default: null
    },
    env: {
      type: Object,
      required: true
    },
    feedback: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      text: this.restoreText(),
      MAX_LEN: MAX_TEXT_LENGTH
    }
  },
  computed: {
    isAnswered () {
      return !!this.feedback
    },
    referenceHtml () {
      return this.feedback && this.feedback.analysis && this.feedback.analysis.reference
    },
    analysisText () {
      return this.feedback && this.feedback.analysis && this.feedback.analysis.text
    }
  },
  methods: {
    restoreText () {
      const t = this.session && this.session.answer && this.session.answer.text
      return typeof t === 'string' ? t : ''
    },
    handleInput (value) {
      if (this.isAnswered) return
      this.text = value
      this.$emit('session-changed', {
        answer: { text: value },
        complete: value.trim() !== ''
      })
    }
  }
}
</script>

<style src="../styles/base.css"></style>

<style scoped>
.qz-shortanswer {
  position: relative;
}

.qz-shortanswer-textarea {
  display: block;
  width: 100%;
  min-height: var(--qz-textarea-min-height, 96px);
  padding: 10px 12px;
  border: 1px solid var(--qz-option-border, #dcdfe6);
  border-radius: var(--qz-control-radius, 6px);
  font-size: 15px;
  line-height: 1.6;
  font-family: inherit;
  color: var(--qz-text, #303133);
  background: var(--qz-input-background, #fff);
  resize: vertical;
  box-sizing: border-box;
  transition: border-color 0.15s ease, box-shadow 0.15s ease, background-color 0.15s ease;
}

.qz-shortanswer-textarea:focus {
  outline: none;
  border-color: var(--qz-primary, #409eff);
  box-shadow: 0 0 0 3px var(--qz-primary-focus-ring, rgba(64, 158, 255, 0.25));
}

.qz-shortanswer-textarea:disabled {
  background: rgba(0, 0, 0, 0.02);
  color: var(--qz-text, #303133);
  opacity: 0.85;
  cursor: default;
}

.qz-shortanswer-count {
  margin-top: 4px;
  font-size: 12px;
  color: var(--qz-text, #303133);
  opacity: 0.6;
  text-align: right;
}

.qz-reference {
  margin-bottom: 6px;
  font-weight: 500;
}

@media (prefers-reduced-motion: reduce) {
  .qz-shortanswer-textarea {
    transition: none;
  }
}
</style>
